import axios from 'axios'

const Axios = axios.create({
  baseURL: 'https://caspian-purchase.lemueltech.com/purchase'
  // baseURL: 'http://localhost:8700/purchase'
  // baseURL: 'http://192.168.43.42:8700/purchase',
})

export const STREAM_URL = 'https://caspian-purchase.lemueltech.com/purchase/';
// export const STREAM_URL = 'http://192.168.43.42:8700/purchase/';
// export const STREAM_URL = 'http://localhost:8700/purchase/';
// export const ACCOUNTING_URL = 'http://localhost:7900/accounting/';

export const ACCOUNTING_URL = 'https://caspian-finance-server-58e8b535cab0.herokuapp.com/accounting';

export default Axios;
